<template>
	<div class="checkbox-container">
		<label class="checkbox-label">
			<input v-show="false" v-model="model" type="checkbox" />
			<div class="checkbox" :class="{ checked: model }">
				<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M14.3667 6.54164L8.80001 12.1083L5.56668 8.87498C5.41054 8.71977 5.19933 8.63265 4.97918 8.63265C4.75903 8.63265 4.54782 8.71977 4.39168 8.87498C4.23647 9.03111 4.14935 9.24232 4.14935 9.46248C4.14935 9.68263 4.23647 9.89384 4.39168 10.05L8.21668 13.875C8.37282 14.0302 8.58402 14.1173 8.80418 14.1173C9.02433 14.1173 9.23554 14.0302 9.39168 13.875L15.5417 7.72498C15.6198 7.64751 15.6818 7.55534 15.7241 7.45379C15.7664 7.35224 15.7882 7.24332 15.7882 7.13331C15.7882 7.0233 15.7664 6.91438 15.7241 6.81283C15.6818 6.71128 15.6198 6.61911 15.5417 6.54164C15.3855 6.38643 15.1743 6.29932 14.9542 6.29932C14.734 6.29932 14.5228 6.38643 14.3667 6.54164V6.54164Z"
						fill="#090E1C"
					/>
				</svg>
			</div>
			<span><slot /></span>
		</label>
	</div>
</template>

<script setup lang="ts">
const model = defineModel<boolean>({
	required: true
});
</script>

<style scoped>
.checkbox-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 6px;
}

.checkbox-label {
	display: flex;
	align-items: center;
	cursor: pointer;
}

.checkbox-input {
	display: none;
}

.checkbox {
	box-sizing: border-box;

	width: 22px;
	height: 22px;
	border: 2px solid rgba(75, 86, 117, 1);
	border-radius: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 8px;
}

.checkbox.checked {
	background-color: rgba(2, 122, 255, 1);
	border: 2px solid rgba(2, 122, 255, 1);
}
</style>
